import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiActions, MiBox } from "@miplatform/components";
import { Box, Typography } from "@mui/material";
import { AreaTemplates } from "./components/AreaTemplates/AreaTemplates";
import { BidDetailsForm } from "./components/BidDetailsForm/BidDetailsForm";
import { CopyExistingPlans } from "./components/CopyExistingPlans/CopyExistingPlans";
import { useCreateBidContext } from "../CreateBidContext";
import { OPTION } from "../constants";

export function BidDetails() {
  const [showBidDetailsForm, setShowBidDetailsForm] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const { classes, cx } = useStyles();
  const { form } = useCreateBidContext();
  const { watch } = form;
  const { name } = watch();

  useEffect(() => {
    if (name) {
      setShowBidDetailsForm(true);
    }
  }, [name]);

  const optionConfigs = [
    {
      id: OPTION.SCRATCH,
      title: "Start From Scratch",
      description: "Nothing comes predefined for you",
      onClick: () => {
        setSelectedOption(OPTION.SCRATCH);
        setShowBidDetailsForm(true);
      },
    },
    {
      id: OPTION.AREA_TEMPLATES,
      title: "Area Templates",
      description: "Floors and areas have been defined",
      onClick: () => {
        setSelectedOption(OPTION.AREA_TEMPLATES);
      },
    },
    {
      id: OPTION.COPY,
      title: "Copy From Existing Plans",
      description: "Everything has been defined floors, areas, and items",
      onClick: () => {
        setSelectedOption(OPTION.COPY);
      },
    },
  ];

  const options = optionConfigs.map((option) => ({
    name: (
      <Box>
        <Typography className={classes.actionTitle}>{option.title}</Typography>
        <Typography variant="caption" color="textSecondary">
          {option.description}
        </Typography>
      </Box>
    ),
    onClick: option.onClick,
    className: cx(
      classes.actionBtn,
      selectedOption === option.id && classes.selectedOption
    ),
  }));

  return (
    <Box className={classes.root}>
      {!showBidDetailsForm && (
        <MiBox headerTitle="Bid Starting Point">
          <Box className={classes.actionBox}>
            <MiActions actions={options} />
          </Box>
          <CopyExistingPlans open={selectedOption === OPTION.COPY} />
          <AreaTemplates open={selectedOption === OPTION.AREA_TEMPLATES} />
        </MiBox>
      )}
      <BidDetailsForm open={showBidDetailsForm} />
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    overflow: "auto",
    height: "100%",
    width: "100%",
    flexDirection: "column",
  },
  actionBox: {
    width: "100%",
    display: "flex",
    gap: theme.spacing(2),
  },
  actionTitle: {
    fontWeight: theme.fontWeight.semiBold,
    color: theme.palette.common.black,
  },
  actionBtn: {
    border: `1px solid ${theme.palette.grey.accent}`,
    width: "100%",
    backgroundColor: theme.palette.grey.light,
  },
  selectedOption: {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.light,
  },
}));
